// extracted by mini-css-extract-plugin
export default {"FirstLoadingLayout__spinner":"Nbv7P"};